import axios from 'axios'
import dayjs from 'dayjs'
import store from '@/store/index'

let CLIENT_GATEWAY = ''
let CLIENT_CD = ''
let CLIENT_DEV = ''
let LOGIN_TOKEN = ''
let LOGIN_USR_CD = ''
let LOGIN_USR_NM = ''
let LOGIN_GRP_CD = ''
let LOGIN_HSP_CD = ''

let currentInstance = null

// 强制重建实例
export function refreshInstance() {
  loginRefresh()

  const baseURL = store.state?.auth?.CLIENT_CONFIG?.client_gate || ''
  console.log('【axios重建】baseURL =', baseURL)

  currentInstance = axios.create({
    baseURL,
    timeout: 15000,
    headers: { 'Content-Type': 'application/json' }
  })

  // 请求拦截
  currentInstance.interceptors.request.use(config => {
    const token = store.state?.auth?.TOKEN_CONFIG?.token
    if (token) {
      config.headers.Authorization = `Bearer ${token}`
    }
    console.log(JSON.stringify(config));
    
    return config
  })

  // 响应拦截
  currentInstance.interceptors.response.use(
    response => response.data,
    error => {
      if (error.response?.status === 401) {
        currentInstance = null // 401 清空实例，强制下次重建
      }
      return Promise.reject(error)
    }
  )
}

// 每次获取前都确保 store 就绪 + 实例有效
function getInstance() {
  const baseURL = store.state?.auth?.CLIENT_CONFIG?.client_gate
  const token = store.state?.auth?.TOKEN_CONFIG?.token

  // 只要 baseURL 或 token 变了/空了 → 强制重建
  if (!currentInstance || !baseURL || !token) {
    refreshInstance()
  }

  return currentInstance
}

export function loginRefresh() {
  const auth = store.state?.auth || {}
  const client = auth.CLIENT_CONFIG || {}
  const token = auth.TOKEN_CONFIG || {}

  CLIENT_GATEWAY = client.client_gate || ''
  CLIENT_CD = client.client_cd || ''
  CLIENT_DEV = client.client_dev || ''
  LOGIN_USR_CD = token.usr_cd || ''
  LOGIN_USR_NM = token.usr_nm || ''
  LOGIN_GRP_CD = token.grp_cd || ''
  LOGIN_HSP_CD = token.hsp_cd || ''
}

function TssMsgBuild(ifm, ifv, ifc, infn, data) {
  return {
    sver: '1.0',
    scode: 'TSA',
    msgid: dayjs().format('YYYYMMDDHHmmss') + (CLIENT_CD || ''),
    mflag: 'os.mgr',
    mtime: dayjs().format('YYYY-MM-DD HH:mm:ss'),
    runid: (CLIENT_DEV || '') + (LOGIN_USR_CD || ''),
    infm: ifm,
    infv: ifv,
    infc: ifc,
    infn: infn,
    devid: CLIENT_CD || '',
    devip: '',
    grp: LOGIN_GRP_CD || '',
    hsp: LOGIN_HSP_CD || '',
    usr: LOGIN_USR_CD || '',
    uname: LOGIN_USR_NM || '',
    input: data || {},
    enc:0
  }
}

// ==================== 对外接口 ====================
export function CallAdo(ifn, data) {
  return getInstance().post('/ado/rdb/v1/proc', TssMsgBuild('ynts-ado', 'v1', 'proc', ifn, data))
}

export function CallAdoMsg(url, ifc, ifn, data) {
  return getInstance().post(url, TssMsgBuild('ynts-ado', 'v1', ifc, ifn, data))
}

export function CallAdocMsg(url, ifm, infv, ifc, ifn, data) {
  return getInstance().post(url, TssMsgBuild(ifm, infv, ifc, ifn, data))
}

export function CallPubMsg(url, data) {
  const base = store.state?.auth?.CLIENT_CONFIG?.client_gate || ''
  
  data.enc = 0
  return getInstance().post(base + url, data)
}

export function FileUpload(formData) {
  loginRefresh()
  formData.append('grp', LOGIN_GRP_CD || '')
  formData.append('hsp', LOGIN_HSP_CD || '')
  formData.append('usr', LOGIN_USR_CD || '')
  return getInstance().post('/file/upload', formData, {
    headers: { 'Content-Type': 'multipart/form-data' },
    withCredentials: true,
    timeout: 30000
  })
}

export function CallFile(data) {
  return getInstance().post('/file/service', TssMsgBuild('ynts-file', 'v1', 'file', 'file', data))
}